import type { Article } from "@/mocks/articles";

export default function ArticleEvidence({ article }: { article: Article }) {
  return (
    <section aria-label="证据链" className="mt-8 rounded-lg bg-secondary-950 p-5 md:p-7">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-background-50">
        <span className="flex h-5 w-5 items-center justify-center text-accent-400">
          <i className="ri-links-line"></i>
        </span>
        证据链 · {article.evidence.length} 条
      </h2>
      <p className="mt-2 text-xs text-background-400">
        以下为可交叉验证的公开线索摘要，仅用于呈现事实基础，不代表最终结论。
      </p>
      <ol className="mt-6 grid grid-cols-1 gap-3 md:grid-cols-2">
        {article.evidence.map((item, index) => (
          <li key={item} className="flex items-start gap-3 rounded-md bg-secondary-900 p-4">
            <span className="flex h-6 w-6 flex-none items-center justify-center rounded-md bg-accent-500 font-heading text-xs font-bold text-foreground-950">
              {index + 1}
            </span>
            <span className="text-sm leading-relaxed text-background-200">{item}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}